<template>
  <normal-card :title="getStepTitle" :icon="getStepIcon">
    <component :is="getStepComponent" :contract="contract" :show="true" />
    <div class="editor-step-buttons">
      <i-button v-if="step !== 0" @click="changeStep(step - 1)">
        Назад
      </i-button>
      <i-button
        v-if="step !== steps.length - 1"
        @click="changeStep(step + 1)"
      >
        Вперед
      </i-button>
    </div>
  </normal-card>
</template>

<script>
import NormalCard from '@/components/parts/normal-card'
import CommonInfo from './common-info'
import PayConditions from './pay-conditions'
import SubInfo from './sub-info'
import Roadmap from './roadmap'
import Prepaid from './prepaid'
import Retention from './retention'
import Documents from './documents'

export default {
  props: ['step', 'steps', 'contract'],
  components: {
    NormalCard,
    CommonInfo,
    PayConditions,
    SubInfo,
    Roadmap,
    Prepaid,
    Retention,
    Documents
  },
  data () {
    return {}
  },
  computed: {
    getStepTitle () {
      return this.steps[this.step].title
    },
    getStepIcon () {
      return this.steps[this.step].icon
    },
    getStepComponent () {
      return this.steps[this.step].component
    }
  },
  methods: {
    changeStep (step) {
      this.$emit('change-step', step)
    }
  }
}
</script>

<style lang="less">
.editor-step-buttons {
  margin-top: 16px;
  display: flex;
  justify-content: flex-end;

  .ivu-btn:last-child {
    margin-left: 8px;
  }
}
</style>
